import React from "react"
import {Card} from "react-bootstrap";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import ImageFluid from "../../components/misc/image-fluid";
import { injectIntl, Link } from "gatsby-plugin-react-intl";

function SimpleCard ({ intl, content }) {
    if (content.button) {
        if (content.button.target) {
            return (
                <div className={content.alignment ? `simple-card ` + content.alignment : `simple-card`}>
                    <Card>
                        <a className={`card-button`} href={content.button.url} target={content.button.target} rel={`noopener`}>
                            {content.header &&
                            <Card.Header>{content.header}</Card.Header>
                            }
                            {content.image &&
                            <div className={`card-image`}>
                                <ImageFluid alt={content.title} filename={content.image} />
                            </div>
                            }
                            <Card.Body>
                                {content.title &&
                                <Card.Title>{content.title}</Card.Title>
                                }
                                {content.subtitle &&
                                <Card.Subtitle className="mb-2 text-muted">{content.subtitle}</Card.Subtitle>
                                }
                                {content.text &&
                                <Card.Text dangerouslySetInnerHTML={{__html: content.text}}></Card.Text>
                                }
                                {content.button &&
                                <div className={`button`}>{content.button.label} <FontAwesomeIcon icon="arrow-right" /></div>
                                }
                            </Card.Body>
                            {content.footer &&
                            <Card.Footer className="text-muted">{content.footer}</Card.Footer>
                            }
                        </a>
                    </Card>
                </div>
            )
        } else {
            return (
                <div className={content.alignment ? `simple-card ` + content.alignment : `simple-card`}>
                    <Card>
                        <Link className={`card-button`} to={content.button.url}>
                            {content.header &&
                            <Card.Header>{content.header}</Card.Header>
                            }
                            {content.image &&
                            <div className={`card-image`}>
                                <ImageFluid alt={content.title} filename={content.image} />
                            </div>
                            }
                            <Card.Body>
                                {content.title &&
                                <Card.Title>{content.title}</Card.Title>
                                }
                                {content.subtitle &&
                                <Card.Subtitle className="mb-2 text-muted">{content.subtitle}</Card.Subtitle>
                                }
                                {content.text &&
                                <Card.Text dangerouslySetInnerHTML={{__html: content.text}}></Card.Text>
                                }
                                {content.button &&
                                <div className={`button`}>{content.button.label} <FontAwesomeIcon icon="arrow-right" /></div>
                                }
                            </Card.Body>
                            {content.footer &&
                            <Card.Footer className="text-muted">{content.footer}</Card.Footer>
                            }
                        </Link>
                    </Card>
                </div>
            )
        }
    } else {
       return(
           <div className={content.alignment ? `simple-card ` + content.alignment : `simple-card`}>
               <Card>
                   {content.header &&
                   <Card.Header>{content.header}</Card.Header>
                   }
                   {content.image &&
                   <div className={`card-image`}>
                       <ImageFluid alt={content.title} filename={content.image} />
                   </div>
                   }
                   <Card.Body>
                       {content.title &&
                       <Card.Title>{content.title}</Card.Title>
                       }
                       {content.subtitle &&
                       <Card.Subtitle className="mb-2 text-muted">{content.subtitle}</Card.Subtitle>
                       }
                       {content.text &&
                       <Card.Text dangerouslySetInnerHTML={{__html: content.text}}></Card.Text>
                       }
                   </Card.Body>
                   {content.footer &&
                   <Card.Footer className="text-muted">{content.footer}</Card.Footer>
                   }
               </Card>
           </div>
       )
    }
}

export default injectIntl(SimpleCard)
